import React from 'react';
import { Grid } from '@mui/material';
import { FeedIcon, VerifiedIcon, EditOffIcon, PublishIcon } from '../../../shared/components/icon';
import MenuButton from '../../common/menuButton/MenuButton';
import { useNavigate } from 'react-router-dom';

const HeaderCreateDocument = () => {
  const navigate = useNavigate();

  const link = window.location.pathname.split('/')[2];

  const buttons = [
    {
      title: 'Importar Documento',
      icon: <FeedIcon color={link === 'document' ? 'success' : 'primary'} sx={{ fontSize: '10em' }} />,
      link: 'document',
    },
    {
      title: 'Revisar Documento',
      icon: <EditOffIcon color={link === 'modify' ? 'success' : 'primary'} sx={{ fontSize: '10em' }} />,
      link: 'modify',
    },
    {
      title: 'Validar Documento',
      icon: <VerifiedIcon color={link === 'validation' ? 'success' : 'primary'} sx={{ fontSize: '10em' }} />,
      link: 'validation',
    },
    {
      title: 'Publicar Documento',
      icon: <PublishIcon color={link === 'publish' ? 'success' : 'primary'} sx={{ fontSize: '10em' }} />,
      link: 'publish',
    },
  ];


  const handleChange = (button) => {
    navigate(button.link);
  };

  return (
    <Grid container spacing={2} justifyContent="space-around" alignItems="center">
      {buttons.map((button) => (
        <Grid item key={button.title} xs={12} sm={6} md={3}>
          <MenuButton
            title={button.title}
            icon={button.icon}
            onClick={() => handleChange(button)}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default HeaderCreateDocument;
